import { gql } from '@apollo/client';

export * from './secureUploadInit.mutation.generated';

export const SECURE_UPLOAD_INIT = gql`
  mutation secureUploadInit($softwareEscrowId: ID!, $numParts: Int!, $filename: String!) {
    secureUploadInit(input: { softwareEscrowId: $softwareEscrowId, numParts: $numParts, filename: $filename }) {
      success
      errors
      uploadId
      uploadUrls
    }
  }
`;
